import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import 'src/index.css';
import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate
import { appStore, persistor } from './redux-store/appStore'; // Import appStore and persistor
import { ModalProvider } from './contexts/LoginModalContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={appStore}>
    <HelmetProvider>
      <SidebarProvider>
        <ModalProvider>
          <BrowserRouter>
            <PersistGate loading={null} persistor={persistor}>
              {' '}
              {/* Wrap with PersistGate */}
              <App />
            </PersistGate>
          </BrowserRouter>
        </ModalProvider>
      </SidebarProvider>
    </HelmetProvider>
  </Provider>
);

serviceWorker.unregister();
